const HANDLE_CHANGE_REPORT_DATE_CONTROLS = 'HANDLE_CHANGE_REPORT_DATE_CONTROLS'

const responseChangeReportDateControls = data => {
  return {
    type: HANDLE_CHANGE_REPORT_DATE_CONTROLS,
    data
  }
}

const openReportDateControls = () => {
  return (dispatch) => {
    dispatch(responseChangeReportDateControls(true))
  }
}

const closeReportDateControls = () => {
  return (dispatch) => {
    dispatch(responseChangeReportDateControls(false))
  }
}

export {
  HANDLE_CHANGE_REPORT_DATE_CONTROLS,
  responseChangeReportDateControls,
  openReportDateControls,
  closeReportDateControls
}